<template>
  <div>
    <v-card class="pa-4 mb-3">
      <v-form
        ref="form"
        lazy-validation
        class="pa-2"
        @submit.prevent="update"
        v-if="user"
      >
        <div class="d-flex justify-space-between">
          <div class="font-bold">
            Update Profile
          </div>
          <v-btn
            tile
            color="primary"
            @click="$router.push({ name: 'user-index' })"
          >
            <v-icon left>
              arrow_back
            </v-icon>
            Back
          </v-btn>
        </div>
        <v-row class="text-center" justify="center">
          <image-picker
            v-model="user.avatar"
            :uploaded="user.avatar !== null"
            @delete-item="user.avatar = null"
            @reset="user.avatar = null"
            class="mb-5"
          >
            <div slot="activator" class="cursor-pointer">
              <img
                :src="user.avatar"
                alt="avatar"
                width="312px"
                height="312px"
                v-if="user.avatar"
              />
            </div>
          </image-picker>
        </v-row>
        <v-row class="mb-2">
          <v-col>
            <v-text-field
              :counter="35"
              outlined
              label="Email"
              v-model="user.email"
              :rules="emailRules"
            ></v-text-field>

            <v-text-field
              :counter="35"
              outlined
              label="First Name"
              v-model="user.firstName"
              :rules="firstNameRules"
            ></v-text-field>
            <v-autocomplete
              v-model="user.type"
              outlined
              :items="types"
              :rules="typeRules"
              label="Select Types"
              item-text="name"
              item-value="id"
              required
            ></v-autocomplete>
          </v-col>

          <v-col>
            <v-text-field
              :counter="35"
              label="GDC Number"
              outlined
              type="number"
              v-model="user.gdcNumber"
              :rules="gdcRules"
            ></v-text-field>

            <v-text-field
              :counter="20"
              label="Last Name"
              outlined
              v-model="user.lastName"
              :rules="lastNameRules"
              required
            ></v-text-field>

            <v-autocomplete
              v-model="user.role"
              :items="roles"
              :rules="roleRules"
              outlined
              label="Select Roles"
              item-text="name"
              item-value="id"
              required
            ></v-autocomplete>

            <v-autocomplete
              v-model="user.userPositionId"
              :items="userPositions"
              outlined
              label="Select Position"
              item-text="name"
              item-value="id"
              required
            ></v-autocomplete>
          </v-col>
          <v-col cols="12" v-if="user.id">
            <address-list :payload="{ from: 0, to: 10, userId: user.id }" />
          </v-col>
          <v-col cols="12">
            <hr />
          </v-col>
          <v-col cols="12" v-if="user.id">
            <phone-list :payload="{ from: 0, to: 10, userId: user.id }" />
          </v-col>
        </v-row>
        <v-row justify="center">
          <div class="mr-4">
            <v-btn color="primary" type="submit" class="mx-0 mt-4"
              >Update</v-btn
            >
          </div>
          <div>
            <v-btn
              color="primary"
              @click="showChangePassword = true"
              type="button"
              class="mx-0 mt-4"
              >Change password</v-btn
            >
          </div>
        </v-row>
        <v-dialog v-model="showChangePassword" width="500">
          <v-form ref="passwordResetForm" @submit.prevent="changeMyPassword">
            <v-card>
              <v-card-title>Change password</v-card-title>
              <v-card-text>
                <v-row>
                  <v-col>
                    <v-text-field
                      hide-details
                      type="password"
                      outlined
                      label="Current Password"
                      v-model="password.oldPassword"
                      :rules="currentPasswordRules"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <v-text-field
                      hide-details
                      outlined
                      type="password"
                      label="New Password"
                      v-model="password.password"
                      :rules="newPasswordRules"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <v-text-field
                      hide-details
                      outlined
                      type="password"
                      label="Re-enter Password"
                      v-model="password.passwordConfirmation"
                      :rules="confirmPasswordRules"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-card-text>

              <v-divider></v-divider>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" text type="submit">
                  Save
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-form>
        </v-dialog>
      </v-form>
    </v-card>
  </div>
</template>
<script>
import { mapState } from "vuex";
import ImagePicker from "@/components/ImagePicker.vue";
import AddressList from "@/components/user_management/address/AddressList.vue";
import PhoneList from "@/components/user_management/phone/PhoneList.vue";
export default {
  components: {
    ImagePicker,
    AddressList,
    PhoneList
  },
  data() {
    return {
      types: ["employee", "owner"],
      roles: ["admin", "user"],
      showChangePassword: false,
      password: {},
      newPassword: null,
      emailRules: [
        v => !!v || "E-mail is required",
        v => /.+@.+\..+/.test(v) || "E-mail must be valid"
      ],
      firstNameRules: [
        v => !!v || "Name is required",
        v => v.length >= 3 || "Name must be at least 3 characters",
        v => v.length <= 35 || "Name must be less than than 35 characters"
      ],
      lastNameRules: [
        v => !!v || "Name is required",
        v => v.length >= 3 || "Name must be at least 3 characters",
        v => v.length <= 35 || "Name must be less than than 35 characters"
      ],
      currentPasswordRules: [
        v => !!v || "Password is required",
        v => v.length >= 6 || "Password must be at least 6 characters",
        v => v.length <= 15 || "Password must be less than 15 characters"
      ],
      newPasswordRules: [
        v => !!v || "Password is required",
        v => v.length >= 6 || "Password must be at least 6 characters",
        v => v.length <= 15 || "Password must be less than 15 characters"
      ],
      confirmPasswordRules: [
        v => !!v || "Password is required",
        v => v.length >= 6 || "Password must be at least 6 characters",
        v => v.length <= 15 || "Password must be less than 15 characters"
      ],
      gdcRules: [
        v => !!v || "GdcNumber is required",
        v => v.length >= 8 || "Phone must be at least 8 digits",
        v => v.length <= 20 || "Phone must be less than than 20 digits"
      ],
      typeRules: [v => !!v || "Type is required"],
      roleRules: [v => !!v || "Role is required"]
    };
  },
  computed: {
    ...mapState({
      user: state => state.auth.authUser,
      userPositions: state => state.users.user_positions,
      suppliers: state => state.suppliers.suppliers,
      surgeries: state => state.surgeries.surgeries
    })
  },
  async mounted() {
    await this.$store.dispatch("auth/LOAD_AUTH_USER");
    await this.$store.dispatch("users/LOAD_USER_POSITIONS");
  },
  methods: {
    async changeMyPassword() {
      if (this.$refs.passwordResetForm.validate()) {
        this.$swal({
          title: "Change password...",
          html: "this will only take a moment",
          icon: "info",
          didOpen: () => {
            this.$swal.showLoading();
          }
        });
        await this.$store
          .dispatch("users/CHANGE_PASSWORD", this.password)
          .then(res => {
            this.$swal.close();
            this.$swal({
              title: "Success",
              html: "Password updated successfully",
              icon: "info"
            });
          })
          .catch(err => {
            this.$swal.close();
            this.$swal({
              title: "Failure",
              html: err,
              icon: "error"
            });
          });
        this.showChangePassword = false;
      }
    },
    saveNewPassword() {
      if (this.$refs.passwordResetForm.validate()) {
        this.$swal({
          title: "Changing password...",
          html: "this will only take a moment",
          icon: "info",
          didOpen: () => {
            this.$swal.showLoading();
          }
        });
      }
    }
  }
};
</script>
